import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import UserList, {PURPLE} from '..';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledOwnersDropdownItem from './StyledOwnersDropdownItem';

const ProjectOwnerList = ({owners, counterState}) => {
	const separator = '//';

	const customItemRender = (item) => {
		const [name, email] = item?.label?.split(separator);

		const maxWidth = 'var(--px-400)';

		return (
			<StyledOwnersDropdownItem>
				<OutputText ellipsis maxWidth={maxWidth} title={name}>
					{name}
				</OutputText>
				<OutputText body2 light ellipsis maxWidth={maxWidth} title={email}>
					{email}
				</OutputText>
			</StyledOwnersDropdownItem>
		);
	};

	const props = {
		triggerVariant: PURPLE,
		list: owners?.map(({firstName, lastName, emailAddress}) => `${firstName} ${lastName}${separator}${emailAddress}`),
		singleLabel: labels.projectOwner,
		pluralLabel: labels.projectOwners,
		customItemRender,
		counterState
	};

	return <UserList {...props} />;
};

ProjectOwnerList.propTypes = {
	count: PropTypes.number
};

ProjectOwnerList.defaultProps = {
	count: 0
};

export default ProjectOwnerList;
